import { ChangeSocial } from './ChangeSocial';

export class ChangeFacebook extends ChangeSocial {
  type: string = 'ChangeFacebook';
}
